import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { isFromDiscoverURL } from "@faire/retailer-visitor-shared/paths/index";
export var useSearchPageIsFromDiscoverURL = function() {
    var location = useZustandLocation(function(state) {
        return state.pathname;
    });
    return isFromDiscoverURL(location.pathname);
};
